/**
 * @file Service for storing the states of views as insight data.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { BreezeService } from '../core/breeze.service';
import * as moment from 'moment';
import { AlertsService } from '../core/alerts.service';
import { EntityManagerService } from '../entity-manager.service';
/**
 * The name of the key property for insight entities.
 */
export var PROPERTY_ID = 'id';
/**
 * Service to retrieve insight data in the local storage of the browser.
 * We using breeze as access layer for the insight data.
 */
var InsightService = /** @class */ (function (_super) {
    tslib_1.__extends(InsightService, _super);
    function InsightService(alertsService, translateService, entityManagerService) {
        var _this = _super.call(this, alertsService, translateService, entityManagerService) || this;
        // WARNING: Do not define an id property in the supported entity types.
        // Instead use the PROPERTY_ID constant.
        /** All the supported insight data entity types. */
        _this.registerEntityTypes = {};
        _this.initialize('insights');
        Object.keys(_this.registerEntityTypes).forEach(function (entityType) {
            _this.metadataStore.registerEntityTypeCtor(entityType, _this.registerEntityTypes[entityType]);
        });
        return _this;
    }
    /**
     * Returns the published until date. Returns infinity for roles higher than EMPLOYEE.
     * @returns {AsyncSubject<Date>} The published until date
     */
    InsightService.prototype.getPublishedTill = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.publishedTill === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.entityManager.executeQuery('GetPublishedTill')];
                    case 1:
                        response = _a.sent();
                        this.publishedTill = moment(response.results[0]).toDate();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.publishedTill];
                }
            });
        });
    };
    /**
     * Gets sets the translate service to use when entities need multi-language logic.
     */
    InsightService.translateService = null;
    return InsightService;
}(BreezeService));
export { InsightService };
